export default "__VITE_ASSET__Dmk2_Bel__"